/**
 * @generated SignedSource<<7ce1172c73cf84df6e265b748ea57f6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreatorContent_nftItem$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileAuctionDetails_nftItem" | "NftItemTileItemDetails_nftItem">;
  readonly " $fragmentType": "CreatorContent_nftItem";
};
export type CreatorContent_nftItem$key = {
  readonly " $data"?: CreatorContent_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreatorContent_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreatorContent_nftItem",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTileItemDetails_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTileAuctionDetails_nftItem"
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "dd8f81d54d0f1df01e87b0050ade5d0c";

export default node;
